import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const COUNTDOWN_DURATION = 48 * 60 * 60 * 1000; // 48 hours in milliseconds
const STORAGE_KEY = 'flash_sale_start_time';

export default function Countdown() {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    // Get or set the start time
    let startTime = localStorage.getItem(STORAGE_KEY);
    
    if (!startTime) {
      startTime = Date.now().toString();
      localStorage.setItem(STORAGE_KEY, startTime);
    }

    const calculateTimeLeft = () => {
      const now = Date.now();
      const elapsed = now - parseInt(startTime, 10);
      let remaining = COUNTDOWN_DURATION - (elapsed % COUNTDOWN_DURATION);

      // If the full 48 hours have passed, reset the timer
      if (elapsed >= COUNTDOWN_DURATION) {
        const newStartTime = Date.now().toString();
        localStorage.setItem(STORAGE_KEY, newStartTime);
        remaining = COUNTDOWN_DURATION;
      }

      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      setTimeLeft({ hours, minutes, seconds });
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatNumber = (num) => String(num).padStart(2, '0');

  return (
    <div 
      data-testid="countdown-timer"
      className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-blue-50 border border-blue-200"
    >
      <Clock className="h-4 w-4 text-blue-600" />
      <span className="text-sm font-medium text-blue-700">
        Flash offer ends in:
      </span>
      <div className="flex items-center gap-1 font-[family-name:Space_Grotesk] text-slate-900 font-semibold">
        <span className="bg-blue-100 px-2 py-0.5 rounded">{formatNumber(timeLeft.hours)}</span>
        <span className="text-blue-600">:</span>
        <span className="bg-blue-100 px-2 py-0.5 rounded">{formatNumber(timeLeft.minutes)}</span>
        <span className="text-blue-600">:</span>
        <span className="bg-blue-100 px-2 py-0.5 rounded">{formatNumber(timeLeft.seconds)}</span>
      </div>
    </div>
  );
}
